/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ExposureFilter } from './ExposureFilter';
import type { PagingAndSortingRequestParam } from './PagingAndSortingRequestParam';

export type ExposureRequest = {
    filter?: ExposureFilter;
    pagingAndSortingRequestParam?: PagingAndSortingRequestParam;
    exposeType?: ExposureRequest.exposeType;
}

export namespace ExposureRequest {

    export enum exposeType {
        EXCEL = 'EXCEL',
        PDF = 'PDF',
        WORD = 'WORD',
        HTML = 'HTML',
        XML = 'XML',
        JSON = 'JSON',
        CSV = 'CSV',
    }


}
